import ListTabs from './ListTabs';

export default ListTabs;
